/**
 * Krok M1 — Swipe pohled (dva ročníky ortofota vedle sebe, vzor Pozemkov).
 * `position` je 0..1 podíl šířky mapy zleva, kde končí "levá" vrstva a
 * začíná "pravá". Čistá geometrie ořezu (OL `prerender`/`postrender` clip
 * volá `ctx.rect(...)` přesně těmito hodnotami) - testovatelná bez plátna.
 *
 * M1 neměl druhý ročník ortofota (`cuzk.ortofoto.archiv.wms` byl BLOCKED).
 * M1b ten zdroj ověřil živě (status VERIFIED, ročníky 1998-2023 v
 * `interactive_layers`), takže swipe v `ParcelMap` je od té doby ZAPNUTÝ —
 * ovládací prvek se vypíná jen tehdy, když vrstva není `available` (T1b:
 * nikdy se netváří jako funkční). Ověřeno znovu v kroku MAP3b (C2).
 */

export interface SwipeClipSize {
  readonly widthPx: number;
  readonly heightPx: number;
}

export interface SwipeClipRect {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

/** Ořez PRAVÉ (druhé) vrstvy - viditelná část je od `position * width` doprava. */
export function swipeClipRect(size: SwipeClipSize, position: number): SwipeClipRect {
  const clamped = Math.min(1, Math.max(0, position));
  const x = clamped * size.widthPx;
  return { x, y: 0, width: size.widthPx - x, height: size.heightPx };
}

/** Ořez LEVÉ (první) vrstvy - doplněk k `swipeClipRect` (spolu pokryjí celou mapu). */
export function swipeClipRectLeft(size: SwipeClipSize, position: number): SwipeClipRect {
  const clamped = Math.min(1, Math.max(0, position));
  return { x: 0, y: 0, width: clamped * size.widthPx, height: size.heightPx };
}
